import { createRequestActions } from '../utils';
import * as dashboardTypes from './dashboardTypes';

export const getDashboardResults = createRequestActions(dashboardTypes.DASHBOARD_RESULT_LIST);
export const listDashboards = createRequestActions(dashboardTypes.DASHBOARD_LIST);
export const dashboard = createRequestActions(dashboardTypes.DASHBOARD);
